import { render, staticRenderFns } from "./setGame2.vue?vue&type=template&id=3a638947&"
import script from "./setGame2.vue?vue&type=script&lang=js&"
export * from "./setGame2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports